import React, { PropsWithChildren } from 'react';
import { IProgressIndicatorStepProps, ProgressIndicatorStep, STATUS_TO_ICON } from './ProgressIndicatorStep';
import { getButtonText, IProgressIndicatorProps } from './ProgressIndicator';
import { DropdownItem } from '../DropdownItem/DropdownItem';
import { Dropdown } from '../Dropdown/Dropdown';
import { Button } from '../../components/Button/Button';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { MATERIAL_ICONS } from '../../components/Icon/icons';
import { DropdownToggle } from '../Dropdown/DropdownToggle';
import { DropdownMenu } from '../Dropdown/DropdownMenu';
import { ProgressIndicatorContext } from './ProgressIndicatorContext';
import { resolveProps } from '../../common/utils';
import { useTestId } from '../../hooks/useTestId/useTestId';

export const ProgressIndicatorStepMobile: React.FC<PropsWithChildren<IProgressIndicatorStepProps> & Pick<IProgressIndicatorProps, 'steps'>> = (props) => {
  const { generateTestId } = useTestId(props, 'ProgressIndicator');
  const contextProps = React.useContext(ProgressIndicatorContext);
  const { position = 1, sheetTitle, steps, t, length = 0 } = resolveProps({ ...contextProps }, { ...props });
  const translate = t ?? getButtonText;

  return (
    <ProgressIndicatorStep {...props} {...generateTestId('mobile')} isMobile isIconSmall hidePosition>
      <Dropdown>
        <DropdownToggle key='dd-toggle'>
          <Button size={SIZES.X_SMALL} endIcon={MATERIAL_ICONS.ExpandMore} {...generateTestId('dd-toggle')}>
            {translate!(position, length)}
          </Button>
        </DropdownToggle>
        <DropdownMenu sheetConfig={{ title: sheetTitle, closable: true }} {...generateTestId('dd-menu')} key='dd-menu'>
          {steps.map(({ icon, iconType, title, status = 'current', ...step }, index) => {
            const suffixText = translate!(step.position ?? index + 1, length);
            return (
              <DropdownItem
                leadingIcon={icon ? { name: icon, type: iconType } : undefined}
                key={`mobile-${title}`}
                label={title}
                suffixText={suffixText}
                trailingIcon={{ ...STATUS_TO_ICON[status] }}
              />
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </ProgressIndicatorStep>
  );
};
